<template>
  <div>
    <h1 class="h2">申請確認者設定</h1>

    <div class="my-5">
      <Btn flat color="primary" icon="backspace" @click="back">戻る</Btn>
    </div>

    <v-card outlined style="padding: 1em; margin-top: 1em;">
      <v-form v-model="valid" ref="form" @submit.prevent="submit">
        <template>
          <v-autocomplete
            v-model="office"
            :items="[office]"
            aria-required="true"
            label="事業所コード"
            outlined
            chips
            item-text="name"
            prepend-icon="mdi-form-select"
            readonly
          ></v-autocomplete>

          <v-autocomplete
            aria-required="true"
            v-model="confimerIdList"
            :items="employeeList"
            label="申請確認者"
            outlined
            prepend-icon="mdi-form-select"
            multiple
            chips
            item-text="name"
            item-value="code"
          ></v-autocomplete>
        </template>

        <div class="d-flex flex-row-reverse">
          <v-btn type="login" color="success">完了</v-btn>
        </div>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import Common from "@/mixins/common";
import Forms from "@/mixins/forms";
import Api from "@/mixins/api";
import ShowDialogs from "@/mixins/showDialogs";
export default {
  name: "ApprovalPetitionDetails",
  mixins: [Common, Forms, Api, ShowDialogs],

  data() {
    return {
      office: null,
      employees: [],
      employeeList: [],
      confimerIdList: []
    };
  },
  methods: {
    back() {
      this.$router.push({ name: "ApprovalPetitionList_new" });
    },
    async submit() {
      const isValid = this.$refs.form.validate();
      if (!isValid) {
        return;
      }
      this.$loading();

      try {
        console.log("employee", this.confimerIdList);
        const isObjectArray = a =>
          Array.isArray(a) && a.every(item => item && typeof item === "object");
        const payload = {
          affiliationList: Array.isArray(this.office)
            ? this.office.map(o => o.code)
            : [this.office.code],
          confirmerList: isObjectArray(this.confimerIdList)
            ? this.confimerIdList.map(e => e.code)
            : this.confimerIdList
        };

        await this.$post(this.Paths.petitiondelete, payload);
        console.log("get : ", payload);

        this.selectedEmployee = [];
        this.selectedOffice = [];
        this.$refs.form.resetValidation();
        this.$info("更新しました。");
        this.$unloading();
      } catch (e) {
        this.$error(e.message);
        this.$unloading();
      } finally {
        this.getPetition();
        this.$unloading();
      }
    }
  },
  async created() {
    this.office = this.$route.params.office;
    const petition = this.$route.params.petition;
    const employee = this.$route.params.employeeName;
    this.selectedOffice = this.office;
    const employeeName = employee.filter(k =>
      petition.map(p => p.confimerId).includes(Number(k.code))
    );
    this.employeeList = employeeName;

    this.confimerIdList = this.employeeList.map(name => ({
      code: employee.filter(e => e.name === name.name)[0].code,
      name: name.name
    }));
    console.log("confimerIdList", this.confimerIdList);
    console.log("employee", employee);
  }
};
</script>
